import React, { useState, useRef } from 'react'
import CreateCustomChat from './CreateCustomChat'
import Cookies from 'js-cookie' // Import Cookies
import { Link } from 'react-router-dom'
import { supabase } from '../../supabaseClient' // Import Supabase client
import { ListGroup, Dropdown } from 'react-bootstrap' // Import Bootstrap components
import useResetSession from '../common/ResetSession' // Import useResetSession hook
import ConfirmationPopup from '../common/ConfirmationPopup' // Import ConfirmationPopup component
import { useEffect,useLayoutEffect } from 'react'

const CustomChatBot = ({ isDarkMode, customChatBotList }) => {
  const [sessions, setSessions] = useState([])
  const [userId, setuserId] = useState(null)
  const activeSessionId = Cookies.get('chat_session_id')
  const [sessionToRemove, setSessionToRemove] = useState(null)
  const [sessionToRename, setSessionToRename] = useState(null)
  const [isNewSession, setIsNewSession] = useState(false)
  const [Loader, setLoader] = useState(false) // Get the active session ID from cookies
  const [isNewChatBot, setIsNewChatBot] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const resetSession = useResetSession() // Initialize the useResetSession hook
  const [showOptions, setShowOptions] = useState(null)
  const [showRemovePopup, setShowRemovePopup] = useState(false)
  const [showFormPopup, setShowFormPopup] = useState(false)
  const [checkedSessions, setCheckedSessions] = useState([])
  const [deleteAllChecked, setDeleteAllChecked] = useState(false)
  const handleNewChatBot = (parentId = null) => {
    setIsNewSession(true)
    setSessionToRename(null)
    setIsNewChatBot(true)
    setShowFormPopup(true)
  }
  const mainSessionRef = useRef(null)
  const optionsRef = useRef(null)
  const ulRef = useRef(null)
  const scrollPosition = useRef(0);
  
  useLayoutEffect(() => {
    const ul = ulRef.current;
    if (ul) scrollPosition.current = ul.scrollTop;
  });
  
  useEffect(() => {
    const ul = ulRef.current;
    if (ul) ul.scrollTop = scrollPosition.current;
  });
  

  const filteredSessions = customChatBotList
    ? customChatBotList.filter(session =>
        session.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : []

  const handleSessionClick = async (sessionId, id) => {
    const { error } = await supabase
      .from('custom_chat_bot')
      .update({ updated_at: new Date() })
      .eq('id', id)

    if (error) {
      console.error('Error updating session timestamp:', error)
    }
    resetSession(sessionId) // Call resetSession with the clicked session's ID
  }
  const handleOptionsClick = sessionId => {
    setShowOptions(showOptions === sessionId ? null : sessionId)
  }
    useEffect(() => {
      const handleClickOutside = event => {
        if (
          mainSessionRef.current &&
          !mainSessionRef.current.contains(event.target) &&
          optionsRef.current &&
          !optionsRef.current.contains(event.target)
        ) {
          setShowOptions(null)
        }
      }
  
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [sessions])
  // useEffect(() => {
  //   if (showOptions) {
  //     // const container = document.querySelector('.sessionBox')
  //     const container = ulRef.current
  //     const optionRefContainer = optionsRef.current
  //     container.scrollTo({
  //       top: container.scrollTop + optionRefContainer.scrollHeight,
  //       behavior: 'smooth'
  //     })
  //   }
  // }, [showOptions])
  useEffect(() => {
    if (showOptions && ulRef.current && optionsRef.current) {
      const container = ulRef.current;
      const popup = optionsRef.current;
  
      const containerRect = container.getBoundingClientRect();
      const popupRect = popup.getBoundingClientRect();
  
      // Check if popup is outside the visible container (bottom overflow)
      if (popupRect.bottom > containerRect.bottom) {
        const scrollOffset = popupRect.bottom - containerRect.bottom + 10; // 10px buffer
        container.scrollBy({
          top: scrollOffset,
          behavior: 'smooth'
        });
      }
  
      // Optional: handle top overflow too

      else if (popupRect.top < containerRect.top) {
        const scrollOffset = containerRect.top - popupRect.top + 10;
        container.scrollBy({
          top: -scrollOffset,
          behavior: 'smooth'
        });
      }
    }
  }, [showOptions]);
  
  const handleRename = sessionId => {
    setSessionToRename(sessionId)
    setIsNewSession(false)
    setShowFormPopup(true)
  }

  const handleRemove = sessionId => {
    if (sessionId) {
      setSessionToRemove(sessionId)
    } else {
      setSessionToRemove(null)
    }
    setShowRemovePopup(true)
  }
  const confirmRemove = async type => {
    if (type) {
      deletSelectedSesion()
    } else {
      var workflowURL = null
      try {
        const {
          data: { session }
        } = await supabase.auth.getSession()

        if (session) {
          const { data: profileData, error: profileError } = await supabase
            .from('profiles')
            .select('chatbot_url')
            .eq('id', session.user.id)
            .single()

          if (profileError) {
            console.error('Error fetching profile data:', profileError)
          } else {
            workflowURL = profileData.chatbot_url
          }
        }
      } catch (error) {
        console.error('Error:', error)
      }
      if (workflowURL != null) {
        const { data, error } = await supabase
          .from('custom_chat_bot')
          .select('*')
          .eq('session_id', sessionToRemove)
          .single()
        if (error) {
          console.error('Error fetching data:', error)
        } else {
          // delete the session
          var AssistantToDelete = data.assistant_id

          var formDataPost = new FormData()
          formDataPost.append('assistant_id', AssistantToDelete)
          formDataPost.append('type', 'delete')

          const response = await fetch(workflowURL, {
            method: 'POST',
            body: formDataPost
          })
          const responseData = await response.json()
          // console.log('Success:', responseData)ss
          if (responseData.status == 'success') {
            const { data: customChatData, error: customChatError } =
              await supabase
                .from('custom_chat_bot')
                .select('*')
                .eq('assistant_id', AssistantToDelete)
                .single()

            if (customChatError) {
              console.error('Error fetching custom chat data:', customChatError)
            } else {
              const sessionId = customChatData.session_id
              const userId = customChatData.user_id

              const { error: deleteCustomChatError } = await supabase
                .from('custom_chat_bot')
                .delete()
                .eq('assistant_id', AssistantToDelete)

              if (deleteCustomChatError) {
                console.error(
                  'Error deleting custom chat bot:',
                  deleteCustomChatError
                )
              } else {
                const { error: chatSessionError } = await supabase
                  .from('chat_session')
                  .delete()
                  .eq('id', sessionId)

                if (chatSessionError) {
                  console.error(
                    'Error deleting chat session:',
                    chatSessionError
                  )
                } else {
                  var files = []
                  let getFileDetails = async type => {
                    const { data, error } = await supabase.storage
                      .from('Storage')
                      .list(`${userId}/${sessionId}/${type}`)
                    data.forEach(element => {
                      files.push(
                        `${userId}/${sessionId}/${type}/${element.name}`
                      )
                    })
                  }
                  let deleteFiles = async files => {
                    const { data, error } = await supabase.storage
                      .from('Storage')
                      .remove(files)
                    if (data) {
                      return true
                    } else {
                      return false
                    }
                  }
                  await getFileDetails('images')
                  await getFileDetails('audios')
                  await getFileDetails('pdfs')
                  let deleteDone = await deleteFiles(files)

                  if (sessionId == Cookies.get('chat_session_bot')) {
                    Cookies.remove('chat_session_bot')
                  }
                }
              }
            }
          }
        }
        window.location.reload()
      }
    }
  }

  const handleCheckboxChange = sessionId => {
    setCheckedSessions(prev =>
      prev.includes(sessionId)
        ? prev.filter(id => id !== sessionId)
        : [...prev, sessionId]
    )
  }

  const handleDeleteAll = () => {
    setDeleteAllChecked(!deleteAllChecked)
    if (deleteAllChecked == false) {
      let allSession = []
      filteredSessions.map(session => {
        allSession.push(session.session_id)
      })
      setCheckedSessions(allSession)
    } else {
      setCheckedSessions([])
    }
  }

  const deletSelectedSesion = async () => {
    var workflowURL = null
    try {
      const {
        data: { session }
      } = await supabase.auth.getSession()

      if (session) {
        const { data: profileData, error: profileError } = await supabase
          .from('profiles')
          .select('chatbot_url')
          .eq('id', session.user.id)
          .single()

        if (profileError) {
          console.error('Error fetching profile data:', profileError)
        } else {
          workflowURL = profileData.chatbot_url
        }
      }
    } catch (error) {
      console.error('Error:', error)
    }

    for (const sessionToRemove of checkedSessions) {
      if (workflowURL != null) {
        const { data, error } = await supabase
          .from('custom_chat_bot')
          .select('*')
          .eq('session_id', sessionToRemove)
          .single()
        if (error) {
          console.error('Error fetching data:', error)
        } else {
          // delete the session
          var AssistantToDelete = data.assistant_id

          var formDataPost = new FormData()
          formDataPost.append('assistant_id', AssistantToDelete)
          formDataPost.append('type', 'delete')

          const response = await fetch(workflowURL, {
            method: 'POST',
            body: formDataPost
          })
          const responseData = await response.json()
          if (responseData.status == 'success') {
            const { data: customChatData, error: customChatError } =
              await supabase
                .from('custom_chat_bot')
                .select('*')
                .eq('assistant_id', AssistantToDelete)
                .single()

            if (customChatError) {
              console.error('Error fetching custom chat data:', customChatError)
            } else {
              const sessionId = customChatData.session_id
              const userId = customChatData.user_id

              const { error: deleteCustomChatError } = await supabase
                .from('custom_chat_bot')
                .delete()
                .eq('assistant_id', AssistantToDelete)

              if (deleteCustomChatError) {
                console.error(
                  'Error deleting custom chat bot:',
                  deleteCustomChatError
                )
              } else {
                const { error: chatSessionError } = await supabase
                  .from('chat_session')
                  .delete()
                  .eq('id', sessionId)

                if (chatSessionError) {
                  console.error(
                    'Error deleting chat session:',
                    chatSessionError
                  )
                } else {
                  var files = []
                  let getFileDetails = async type => {
                    const { data, error } = await supabase.storage
                      .from('Storage')
                      .list(`${userId}/${sessionId}/${type}`)
                    data.forEach(element => {
                      files.push(
                        `${userId}/${sessionId}/${type}/${element.name}`
                      )
                    })
                  }
                  let deleteFiles = async files => {
                    const { data, error } = await supabase.storage
                      .from('Storage')
                      .remove(files)
                    if (data) {
                      return true
                    } else {
                      return false
                    }
                  }
                  await getFileDetails('images')
                  await getFileDetails('audios')
                  await getFileDetails('pdfs')
                  let deleteDone = await deleteFiles(files)

                  if (sessionId == Cookies.get('chat_session_bot')) {
                    Cookies.remove('chat_session_bot')
                  }
                }
              }
            }
          }
        }
      }
    }
    window.location.reload()
    setCheckedSessions([])
  }

  return (
    <>
      <div ref={mainSessionRef} className='custom-chatbot-harsh'>
        <div
          className='search-container'
          style={{
            padding: '10px'
          }}
        >
          <div
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <i
              className='bi bi-search'
              style={{
                position: 'absolute',
                left: '10px',
                color: '#666'
              }}
            ></i>
            <input
              type='text'
              placeholder='Search Chatbots...'
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 32px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
            {searchQuery && (
              <i
                className='bi bi-x'
                style={{
                  position: 'absolute',
                  right: '10px',
                  color: '#666',
                  cursor: 'pointer'
                }}
                onClick={() => setSearchQuery('')}
              ></i>
            )}
          </div>
        </div>
        <ul
          className='sessionBox'
          ref={ulRef}
          style={{
            paddingLeft: '10px',
            paddingTop: '10px',
            overflowY: 'auto',
             maxHeight: '400px'
          }}
        >
          <li className='me-2' onClick={() => handleNewChatBot(null)}>
            <i className='bi bi-plus-square-dotted'></i> New Chatbot
          </li>
          {checkedSessions.length > 0 && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px 0',
                marginLeft: '1rem'
              }}
            >
              <input
                type='checkbox'
                checked={deleteAllChecked}
                onChange={handleDeleteAll}
                style={{
                  marginRight: '10px',
                  cursor: 'pointer'
                }}
              />
              <i
                className='bi bi-trash'
                style={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  handleRemove(null)
                }}
              >
                {' '}
                Delete {checkedSessions.length} of {filteredSessions.length}
              </i>
            </div>
          )}
          {filteredSessions.length > 0 ? (
            filteredSessions.map(session => (
              <li
                key={session.session_id}
                // className='d-flex justify-content-between align-items-center mb-3 py-0 border-0'
                className={
                  session.session_id === activeSessionId
                    ? 'active-session d-flex justify-content-between align-items-center mb-2 border-0 me-2'
                    : 'd-flex justify-content-between align-items-center border-0 me-2'
                }
                style={{
                  backgroundColor:
                    session.session_id === activeSessionId
                      ? '#e9ecef'
                      : 'transparent',
                  fontWeight: 100
                }}
                // ref={
                //   session.session_id === activeSessionId
                //     ? el => {
                //         if (el) {
                //           el.scrollIntoView({
                //             behavior: 'smooth',
                //             block: 'center'
                //           })
                //         }
                //       }
                //     : null
                // }
              >
                <div className='d-flex align-items-center' style={{cursor:'default'}}>
                  {filteredSessions.length > 1 ? (
                    <input
                      type='checkbox' 
                      style={{ marginRight: '8px', cursor: 'pointer' }}
                      checked={checkedSessions.includes(session.session_id)}
                      onChange={() => handleCheckboxChange(session.session_id)}
                    />
                  ) : null}
                  <Link
                    onClick={() =>
                      handleSessionClick(session.session_id, session.id)  
                    }
                    className='text-decoration-none'
                    style={{ color: 'black' }}
                  >
                    <i
                      className='bi bi-chat-left linkItem'
                      style={{ marginRight: '8px', padding: '10px' }}
                    ></i>
                    <b>{session.name}</b>
                  </Link>
                </div>
                {/* <div>
                    <Dropdown
                      align='end'
                      show={showOptions === session.session_id}
                      onToggle={() => handleOptionsClick(session.session_id)}
                    >
                      <Dropdown.Toggle variant='' bsPrefix='p-0'>
                        <i
                          className='bi bi-three-dots-vertical'
                          style={{ fontSize: '1em', cursor: 'pointer' }}
                        ></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => handleRename(session.session_id)}
                        >
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          className='text-danger'
                          onClick={() => handleRemove(session.session_id)}
                        >
                          Remove
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div> */}
                <div style={{ position: 'relative' }}>
                  <i
                    className='bi bi-three-dots-vertical'
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleOptionsClick(session.session_id)}
                  ></i>
                  {showOptions === session.session_id && (
                    <div
                      ref={optionsRef}
                      style={{
                        zIndex: '999999',
                        textAlign: 'center',
                        width: '125px',
                        position: 'absolute',
                        right: 0,
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                      }}
                    >
                      <div
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #ccc',
                          color: 'black'
                        }}
                        onClick={() => handleRename(session.session_id)}
                      >
                        Edit
                      </div>
                      <div
                        style={{ padding: '10px', cursor: 'pointer' }}
                        className='text-danger'
                        onClick={() => handleRemove(session.session_id)}
                      >
                        Remove
                      </div>
                    </div>
                  )}
                </div>
              </li>
            ))
          ) : (
            <div className='text-center'>No data found</div>
          )}
        </ul>
        <CreateCustomChat
          isDarkMode={isDarkMode}
          show={showFormPopup}
          isNewSession={isNewSession}
          sessionToRename={sessionToRename}
          onClose={() => setShowFormPopup(false)}
          onSubmit={() => {
            // handle submit logic here
            setShowFormPopup(false)
          }}
        ></CreateCustomChat>
        <ConfirmationPopup
          show={showRemovePopup}
          handleClose={() => setShowRemovePopup(false)}
          title='Confirm Removal'
          body='Are you sure you want to remove this ChatBot? This action cannot be undone.'
          handleConfirm={() =>
            confirmRemove(sessionToRemove == null ? true : false)
          }
        />
      </div>
    </>
  )
}

export default CustomChatBot
